'use client';

import React, { createContext, useContext, useMemo } from 'react';
import type { VendingMachineLocation } from '~/contracts/vm';

export type ContextType = {
  vendingMachineLocations: VendingMachineLocation[];
};

const defaultContext: ContextType = {
  vendingMachineLocations: []
};

const VendingMachineDataContext = createContext<ContextType>(defaultContext);

export type OwnProps = React.PropsWithChildren<{
  vendingMachineLocations: VendingMachineLocation[];
}>;

export function VendingMachineDataContextProvider(props: OwnProps) {
  const value: ContextType = useMemo<ContextType>(
    () => ({
      vendingMachineLocations: props.vendingMachineLocations
    }),
    [props.vendingMachineLocations]
  );

  return (
    <VendingMachineDataContext.Provider value={value}>
      {props.children}
    </VendingMachineDataContext.Provider>
  );
}

VendingMachineDataContextProvider.displayName =
  'VendingMachineDataContextProvider';

export const useVendingMachineDataContext = () =>
  useContext(VendingMachineDataContext);

export default VendingMachineDataContext;
